/**
 * IndexedDB の薄い口。**タスクデータのキャッシュ以外に使わない**ので、
 * ストア1つ・キー1つの get/put/delete しか持たない。
 *
 * localStorage を使わないのは、タスクデータが数MBあり 5MB 前後の枠に収まらないため。
 */

const DB_NAME = 'tarkov-map-pins'
const DB_VERSION = 1
const STORE = 'cache'

let dbPromise: Promise<IDBDatabase> | null = null

function open(): Promise<IDBDatabase> {
  dbPromise ??= new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE)
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
  return dbPromise
}

function run<T>(mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest): Promise<T> {
  return open().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const tx = db.transaction(STORE, mode)
        const req = fn(tx.objectStore(STORE))
        req.onsuccess = () => resolve(req.result as T)
        req.onerror = () => reject(req.error)
      }),
  )
}

/**
 * プライベートウィンドウや設定によっては IndexedDB が使えない。
 * **その場合もアプリは動く**（毎回取り直すだけ）ので、失敗は握って undefined を返す。
 */
export async function idbGet<T>(key: string): Promise<T | undefined> {
  try {
    return await run<T | undefined>('readonly', (s) => s.get(key))
  } catch {
    return undefined
  }
}

export async function idbPut(key: string, value: unknown): Promise<void> {
  try {
    await run('readwrite', (s) => s.put(value, key))
  } catch {
    // 保存できなくても、次回また取りに行くだけ
  }
}

export async function idbDelete(key: string): Promise<void> {
  try {
    await run('readwrite', (s) => s.delete(key))
  } catch {
    /* 同上 */
  }
}
